import axios from 'axios';

// Usar variável de ambiente ou URL relativa
const API_URL = process.env.REACT_APP_API_URL || window.location.origin + '/api';

export interface User {
  id: number;
  username: string;
  name: string;
  email: string;
}

export interface AuthResponse {
  user: User;
}

class AuthService {
  async login(username: string, password: string): Promise<AuthResponse> {
    const response = await axios.post<AuthResponse>(`${API_URL}/login`, {
      username,
      password,
    }, {
      withCredentials: true, // Importante para cookies HttpOnly
    });
    
    return response.data;
  }
  
  async logout(): Promise<void> {
    await axios.post(`${API_URL}/logout`, {}, {
      withCredentials: true,
    });
  }
  
  async getCurrentUser(): Promise<User | null> {
    try {
      const response = await axios.get<{ user: User }>(`${API_URL}/me`, {
        withCredentials: true,
      });
      return response.data.user;
    } catch (error) {
      return null;
    }
  }
  
  isAuthenticated(): Promise<boolean> {
    return this.getCurrentUser().then(user => !!user);
  }
}

export default new AuthService();
